"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#24292E' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.9166 14.9999L12.3809 9.99992M7.61901 9.99992L2.08332 14.9999M1.66663 5.83325L8.47072 10.5961C9.0217 10.9818 9.29719 11.1746 9.59685 11.2493C9.86154 11.3153 10.1384 11.3153 10.4031 11.2493C10.7027 11.1746 10.9782 10.9818 11.5292 10.5961L18.3333 5.83325M5.66663 16.6666H14.3333C15.7334 16.6666 16.4335 16.6666 16.9683 16.3941C17.4387 16.1544 17.8211 15.772 18.0608 15.3016C18.3333 14.7668 18.3333 14.0667 18.3333 12.6666V7.33325C18.3333 5.93312 18.3333 5.23306 18.0608 4.69828C17.8211 4.22787 17.4387 3.84542 16.9683 3.60574C16.4335 3.33325 15.7334 3.33325 14.3333 3.33325H5.66663C4.26649 3.33325 3.56643 3.33325 3.03165 3.60574C2.56124 3.84542 2.17879 4.22787 1.93911 4.69828C1.66663 5.23306 1.66663 5.93312 1.66663 7.33325V12.6666C1.66663 14.0667 1.66663 14.7668 1.93911 15.3016C2.17879 15.772 2.56124 16.1544 3.03165 16.3941C3.56643 16.6666 4.26649 16.6666 5.66663 16.6666Z",
    stroke: fill,
    "stroke-width": "1.66667",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }));
};

exports["default"] = _default;